import firebase from 'firebase/app';
import firestore from 'firebase/firestore';


// Your web app's Firebase configuration
var firebaseConfig = {
  apiKey: "AIzaSyCPsH5qtT99aS_gmO82nu9_sEy-q9Mg-cM",
  authDomain: "app.earbeater.com",
  databaseURL: "https://earbeater-2e6c7.firebaseio.com",
  projectId: "earbeater-2e6c7",
  storageBucket: "earbeater-2e6c7.appspot.com",
  messagingSenderId: "1075433643569",
  appId: "1:1075433643569:web:46c2e50e7f30587c217f10"
};
// Initialize Firebase
const firebaseApp = firebase.initializeApp(firebaseConfig);

export default firebaseApp.firestore();